//@flow
import { Volume } from 'common/models/internal/Volume';
import { Dimensions } from 'common/models/internal/Dimensions';
import isString from 'lodash/isString';

export class LineItemHelper {
    static updateDimensions({ volume }) {
        // This is done for backward compatibility where volume come as "1,2,3" for dimensions
        if (volume && isString(volume.value) && volume.value.indexOf(',') > 0) {
            const [length, breadth, height] = volume.value.split(',');
            return {
                volume: Volume.fromJS({
                    unit: volume.unit,
                    value: length * breadth * height
                }),
                dimensions: Dimensions.fromJS({ length, breadth, height })
            };
        }
        return {};
    }
}

export default LineItemHelper;
